import { render, staticRenderFns } from "./AccountSidebar.vue?vue&type=template&id=555f030e&scoped=true&"
import script from "./AccountSidebar.vue?vue&type=script&lang=js&"
export * from "./AccountSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AccountSidebar.vue?vue&type=style&index=0&id=555f030e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f030e",
  null
  
)

export default component.exports